export const portfolioData = [
	{
		name: "Gulfstream News",
		tech: "UIKit, Webpack, Babel, AWS (DynamoDB, S3, Cognito, Lambda, CloudFront), Jekyll",
		desc: `Full stack development of informational site for <a href="https://gulfstream.com" target="_blank">Gulfstream Aerospace</a> aimed at media partners.`,
		image: "gulfstreamnews.png",
		url: "https://gulfstreamnews.com"
	},
	{
		name: "The Woman in the Marsh",
		tech: "HTML/CSS/JavaScript",
		desc: "An example of special news presentation using custom HTML, CSS and javascript.",
		image: "BehindTheHotel.gif",
		url: "http://media.islandpacket.com/static/news/daryan/"
	},
	{
		name: "Close calls and regrets",
		tech: "HTML/CSS/JavaScript",
		desc: "Custom news presentation about people who refused to evacuate for Hurricane Matthew, using HTML, CSS and javascript",
		image: "matthewWind.gif",
		url: ""
	},
	{
		name: "A day in the field: Ride along with these Lowcountry foxhunters",
		tech: "HTML/CSS/JavaScript",
		desc: "Custom news presentation about a foxhunting club in Colleton County, S.C., using HTML, CSS and javascript",
		image: "foxHunting.jpg",
		url: "http://media.islandpacket.com/static/news/foxhunt/"
	},
	{
		name: "Finn's extraordinary adventure",
		tech: "HTML/CSS/JavaScript",
		desc: "Custom news presentation on the unusual efforts to find and rescue a dog lost on Spring Island, S.C., using HTML, CSS and javascript",
		image: "finn_splash2.jpg",
		url: "http://media.islandpacket.com/static/news/finn/"
	}
];
